export function buildChangedSettingsPatch(
  draft: Record<string, unknown>,
  persisted: Record<string, unknown> | undefined,
) {
  return Object.fromEntries(
    Object.entries(draft).filter(
      ([key, value]) => JSON.stringify(value) !== JSON.stringify(persisted?.[key]),
    ),
  );
}
